import { Paper } from "@material-ui/core";
import { saveAs } from "file-saver";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import lodingProgressOrPleaseWait from "../images/lodingProgressOrPleaseWait.gif";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";

const SelectClips = ({ selectedVideos, setSelectedVideos }) => {
  const [downloading, setDownloading] = useState(false);

  const videoList = useSelector((state) => state.selectedSeasonData.videoList);
  const selectedSeasonData = useSelector(
    (state) => state.selectedSeasonData.selectedSeasonData
  );
  const selectedEvent = useSelector(
    (state) => state.selectedSeasonData.selectedEventData
  );
  const dispatch = useDispatch();

  const handleSelectOrUnselect = (checked, item) => {
    if (checked) {
      if (selectedVideos.length === videoList.videoArr.length) {
        setSelectedVideos([item]);
      } else {
        setSelectedVideos([...selectedVideos, item]);
      }
    } else {
      setSelectedVideos(
        selectedVideos.filter((videos) => videos.id !== item.id)
      );
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedVideos(
        Object.keys(videoList.videoArr).map((item) => videoList.videoArr[item])
      );
    } else {
      setSelectedVideos([]);
    }
  };

  const checkSelect = (item) => {
    var i;
    for (i = 0; i < selectedVideos.length; i++) {
      if (selectedVideos[i].id === item.id) {
        return true;
      }
    }
    return false;
  };

  const handleDownload = () => {
    setDownloading(true);
    selectedVideos.map((item, i, row) => {
      fetch(item.videoPath, { method: "GET" })
        .then((res) => {
          return res.blob();
        })
        .then((blob) => {
          saveAs(blob, item.eventMediaCategory);
          if (i + 1 === row.length) {
            setDownloading(false);
          }
        })
        .catch((err) => {
          console.error("err: ", err);
        });
    });
  };

  const handleDelete = () => {
    const eventMediaIds = selectedVideos.map((item) => item.id);
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        eventMediaId: eventMediaIds,
        open: true,
        message: "Are You Sure You Want To Delete This Video ?",
        btnColor: "red",
        btnText: "Delete",
        type: "Delete Video From Past Season",

        seasonType:
          typeof selectedEvent === "object" &&
          Object.keys(selectedEvent).length &&
          selectedEvent[0]?.weekName
            ? "in-season"
            : typeof selectedEvent === "object" &&
              Object.keys(selectedEvent).length &&
              selectedEvent[0]?.eventName
            ? "off-season"
            : "other",
        eventType: videoList.eventType,
        weekName: videoList.weekName,
        offSeasonEventName: videoList.offSeasonEventName,
        practiceName: videoList.practiceName,
        otherSeasonEventType: videoList.otherSeasonEventType,
        videoId: eventMediaIds,
        isVideoRenamed: false,
        seasonName: selectedSeasonData.seasonName,
      },
    });
  };
  return (
    <>
      {typeof videoList?.videoArr === "object" &&
      Object.keys(videoList?.videoArr).length ? (
        <Paper className="min-width-450">
          <div className="d-flex-space-between light-grey-border-bottom">
            <h1 className="storage-title bold">Select Clips</h1>
            <div className="d-flex-align-cent gap-10 mg-right-10">
              <button
                className={`common-btn green ${
                  !selectedVideos.length && "disabled"
                }`}
                disabled={!selectedVideos.length}
                onClick={handleDownload}
              >
                {downloading ? (
                  <img
                    src={lodingProgressOrPleaseWait}
                    alt="Please Wait"
                    title="Please Wait"
                    className="dwnldIMG"
                  />
                ) : (
                  "Download"
                )}
              </button>
              <button
                className={`common-btn red ${
                  !selectedVideos.length && "disabled"
                }`}
                disabled={!selectedVideos.length}
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
          <div className="current-video">
            <div className="d-flex-align-cent gap-10 mg-bottom-10">
              <Checkbox
                onChange={(e) => handleSelectAll(e.target.checked)}
                icon={<BsCircle fontSize="20px" color="#13005A" />}
                checkedIcon={
                  <BsFillCheckCircleFill fontSize="20px" color="#13005A" />
                }
                checked={
                  selectedVideos.length ===
                  Object.keys(videoList?.videoArr).length
                }
                className="videolibrary-checkbox-icon"
              />
              <p>Select All</p>
            </div>
            {Object.keys(videoList?.videoArr).map((item, index) => (
              <div className="d-flex-align-cent gap-10">
                <div key={index} className="d-flex-align-cent gap-10">
                  <Checkbox
                    onChange={(e) =>
                      handleSelectOrUnselect(
                        e.target.checked,
                        videoList?.videoArr[item]
                      )
                    }
                    icon={<BsCircle fontSize="20px" color="#13005A" />}
                    checkedIcon={
                      <BsFillCheckCircleFill fontSize="20px" color="#13005A" />
                    }
                    checked={checkSelect(videoList?.videoArr[item])}
                    className="videolibrary-checkbox-icon"
                  />
                  <video
                    src={videoList?.videoArr[item].videoPath}
                    className="videoImg"
                  />
                </div>
                <div>
                  <p>{videoList?.videoArr[item].eventMediaCategory}</p>
                </div>
              </div>
            ))}
          </div>
        </Paper>
      ) : null}
    </>
  );
};

export default SelectClips;
